var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:_vm.className,style:(_vm.indicatorStyle),on:{"click":_vm.click}},[(_vm.src)?_c('img',{staticClass:"d-block w-100 img-fluid",attrs:{"src":_vm.src,"alt":_vm.alt}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }